import { Link } from '@tanstack/react-router';
import { LandingNav } from './landing/LandingNav';
import { FooterSection } from './landing/FooterSection';
import { ArrowLeft } from 'lucide-react';

export function About() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingNav />
      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <Link to="/" className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-8">
            <ArrowLeft className="mr-1 h-4 w-4" />
            Back to Home
          </Link>

          <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-8">About EU ServiceLine</h1>

          <div className="space-y-6 text-muted-foreground leading-relaxed">
            <p>
              EU ServiceLine is a comprehensive helpdesk platform built by Easton Utilities to
              streamline customer support operations. Designed from the ground up as a multi-tenant
              solution, it enables organizations to manage tickets, automate workflows, and deliver
              exceptional customer service — all from a single unified platform.
            </p>

            <h2 className="text-xl sm:text-2xl font-semibold text-foreground pt-4">Our Mission</h2>
            <p>
              We believe customer support should be efficient, transparent, and collaborative.
              EU ServiceLine empowers support teams with the tools they need to respond faster,
              automate repetitive tasks, and keep customers informed at every step.
            </p>

            <h2 className="text-xl sm:text-2xl font-semibold text-foreground pt-4">What We Offer</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong className="text-foreground">Ticket Management</strong> — Full lifecycle tracking
                with SLA-aware timelines, priority management, and real-time collaboration.
              </li>
              <li>
                <strong className="text-foreground">No-Code Automation</strong> — Build powerful rules
                that automatically assign, notify, escalate, and close tickets without writing code.
              </li>
              <li>
                <strong className="text-foreground">Customer Self-Service</strong> — A dedicated customer
                portal with magic link authentication, ticket submission, and knowledge base access.
              </li>
              <li>
                <strong className="text-foreground">Multi-Channel Notifications</strong> — Keep your team
                and customers informed via email, in-app, push, and real-time alerts.
              </li>
              <li>
                <strong className="text-foreground">Analytics & Reporting</strong> — Track SLA compliance,
                team performance, and ticket trends with built-in dashboards.
              </li>
              <li>
                <strong className="text-foreground">Multi-Tenant Architecture</strong> — Complete data
                isolation per organization with per-org branding and configuration.
              </li>
            </ul>

            <h2 className="text-xl sm:text-2xl font-semibold text-foreground pt-4">Built by Easton Utilities</h2>
            <p>
              EU ServiceLine is developed and maintained by Easton Utilities, based in Easton, Maryland.
              Our team combines deep expertise in utility operations with modern software engineering
              to build tools that make a real difference for support teams.
            </p>

            <h2 className="text-xl sm:text-2xl font-semibold text-foreground pt-4">Get in Touch</h2>
            <p>
              Interested in learning how EU ServiceLine can transform your support operations?{' '}
              <Link to="/" hash="contact" className="text-primary hover:underline">
                Contact us
              </Link>{' '}
              to schedule a conversation.
            </p>
          </div>
        </div>
      </main>
      <FooterSection />
    </div>
  );
}
